var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeS7P2BB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 149,
    viewBox: "0 0 196 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2141_349)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2141_349",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 292,
    height: 149
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-3.05176e-05 0.88623H292V148.886H-3.05176e-05V0.88623Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2141_349)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3.05176e-05 75.6802V108.879C24.4219 132.116 93.7791 148.863 175.502 148.863C205.293 148.978 235.041 146.562 264.424 141.643L292 135.794V102.618C260.195 110.787 219.66 115.676 175.502 115.676C93.7791 115.676 24.4219 98.9169 -3.05176e-05 75.6916",
    fill: "#B7AAA3",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.885 54.4884C95.379 56.4762 44.2039 69.6482 32.3301 86.6588C30.6809 84.4678 29.7616 81.8145 29.7016 79.0732C29.7016 58.7039 85.1966 41.899 156.92 39.3971L154.634 22.1466C79.3683 25.0026 18.8106 43.0071 4.68546 66.2781C2.69341 63.1587 1.60553 59.5482 1.54272 55.8479C1.54272 25.5282 79.4597 0.88623 175.467 0.88623V54.1799L158.885 54.4884Z",
    fill: "#B7AAA3",
    fillOpacity: 0.4
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2141_349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 292,
    height: 148,
    fill: "white",
    transform: "matrix(-1 0 0 1 292 0.88623)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeS7P2BB);
export default __webpack_public_path__ + "static/media/HomeS7P2B-B.5d72227ed4091ee57aa6cbcfb5fc1c83.svg";
export { ForwardRef as ReactComponent };